import { IAction } from '@/store/types/action'
import { SHOW_FEEDBACK_FINISH, SHOW_FEEDBACK_INIT } from './mutation-types'
import { FeedbackType, IState } from './types'

interface IShowFeedback {
  message: string,
  feedbackType: FeedbackType,
  time: number
}

const showFeedback: IAction<IState, IShowFeedback>  = ({ commit }, { message, feedbackType, time }) => {
  commit(SHOW_FEEDBACK_INIT, { message, feedbackType })

  setTimeout(() => {
    commit(SHOW_FEEDBACK_FINISH)
  }, time || 2000)
}

export default { showFeedback }
